export default {
  'account.password.title': '修改密码',
  'account.password.subtitle': '更新您的登录密码',
  'account.password.loggedInAs': '当前账户：{username}',
  'account.password.current': '当前密码',
  'account.password.currentPlaceholder': '请输入当前密码',
  'account.password.currentRequired': '请输入当前密码',
  'account.password.new': '新密码',
  'account.password.newPlaceholder': '请输入新密码',
  'account.password.newRequired': '请输入新密码',
  'account.password.confirm': '确认新密码',
  'account.password.confirmPlaceholder': '请再次输入新密码',
  'account.password.confirmRequired': '请确认新密码',
  'account.password.minLength': '密码至少 6 位字符',
  'account.password.mismatch': '两次输入的新密码不一致',
  'account.password.submit': '保存新密码',
  'account.password.success': '密码修改成功，请使用新密码重新登录',
  'account.password.failed': '密码修改失败，请稍后重试',
  'account.password.notLoggedIn': '请先登录',
};
